import { render } from "./NewDepartmentForm.vue?vue&type=template&id=4e8bbf0a&scoped=true"
import script from "./NewDepartmentForm.vue?vue&type=script&lang=js"
export * from "./NewDepartmentForm.vue?vue&type=script&lang=js"

import "./NewDepartmentForm.vue?vue&type=style&index=0&id=4e8bbf0a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8bbf0a"]])

export default __exports__